import React from 'react';
import { ManageScreensPage } from './screens/ManageScreensPage';
import { ScreenDetailPage } from './screens/ScreenDetailPage';

/** Beam on Screen → Manage Screens (`/#/beamonscreen/manage-screens`). */
export const ManageScreens: React.FC = () => <ManageScreensPage title="Manage Screens" />;

/** Beam on Screen → one screen (`/#/beamonscreen/manage-screens/:screenId`). */
export const ManageScreenDetail: React.FC = () => <ScreenDetailPage />;
